import { useMemo } from "react";
import { APOLLO_STATE_PROP_NAME } from "../../constants";
import getOrCreateApolloClient from "./getOrCreateApolloClient";

/** Hook to get the current ApolloClient instance
 * ---
 * NOTE: this is preferred over `useApolloClient()` in most cases to make
 * sure that we're sharing the singleton.
 */

function useCurrentApolloClient(pageProps: any) {
  const state = pageProps[APOLLO_STATE_PROP_NAME];
  return useMemo(() => getOrCreateApolloClient(state), [state]);
}

export default useCurrentApolloClient;
